import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQuantity = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 19,
	height: 18,
	fill: "none",
	viewBox: "0 0 19 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "M0 10h10v8H0v-8Zm2 2v4h6v-4H2ZM9.2.8 19 3.4 16.8 11 7.1 8.5 9.2.8Zm1.4 2.4-1 3.9 5.8 1.5 1-3.8-5.8-1.6Z",
		clipRule: "evenodd"
	})
});
export default SvgQuantity;
